import React, { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import "react-chat-widget/lib/styles.css";
import { TextField,Popper, Autocomplete, FormControlLabel, LinearProgress, Avatar, Menu, MenuItem, Tooltip, Zoom, IconButton, Popover, Switch } from "@mui/material";
import { styled } from "@mui/material/styles";
import EastOutlinedIcon from "@mui/icons-material/EastOutlined";
import ReactReadMoreReadLess from "react-read-more-read-less";
import MicOutlinedIcon from "@mui/icons-material/MicOutlined";
import FileUploadOutlinedIcon from "@mui/icons-material/FileUploadOutlined";
import FolderOutlinedIcon from "@mui/icons-material/FolderOutlined";
import TravelExploreIcon from "@mui/icons-material/TravelExplore";
import all from "../assets/images/browser.png";
import Academic from "../assets/images/books.png";
import Writing from "../assets/images/pen.png";
import divide from "../assets/images/divide.png";
import youtube from "../assets/images/youtube.png";
import reddit from "../assets/images/reddit.png";
import AddIcon from "@mui/icons-material/Add";
import AddBrain from "./add-brain";
import CloseIcon from "@mui/icons-material/Close";
import { motion } from "framer-motion";
import MessageSnackbar from "../_layout/elements/snackbar";
import openai from "../assets/images/openaiicon.webp";
import SwitchAccessShortcutAddIcon from "@mui/icons-material/SwitchAccessShortcutAdd";

const CustomPopper = styled(Popper)({
  zIndex: 1300,
});
const ChatForm = (props) => {
  const [searchParams] = useSearchParams();

  const brainId = searchParams.get("brainId");
  //filter open  function start//
  const [anchorElattachment, setAnchorElattachment] = React.useState(null);
  const handleClickattachment = (event) => {
    setAnchorElattachment(event.currentTarget);
  };
  const handleCloseattachment = () => {
    setAnchorElattachment(null);
  };
  const openattachment = Boolean(anchorElattachment);
  //filter open  function end//
  //audio listening    function start//
  const [isListening, setIsListening] = useState(false);
  const handleMicButtonClick = () => {
    setIsListening((prevState) => !prevState);
  };
  //audio listening    function end//]
  //this below function for add brain   popup start//
  const [openaddbrain, setOpendeleteaddbrain] = React.useState(false);
  const activeaddbrain = () => setOpendeleteaddbrain(true);
  const handleCloseaddbrain = () => setOpendeleteaddbrain(false);
  //this below function for add brain   popup end//
  const IOSSwitch = styled((props) => <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />)(({ theme }) => ({
    width: 38,
    height: 20,
    padding: 0,
    "& .MuiSwitch-switchBase": {
      padding: 0,
      margin: 2,
      transitionDuration: "300ms",
      "&.Mui-checked": {
        transform: "translateX(16px)",
        color: "#fff",
        "& + .MuiSwitch-track": {
          backgroundColor: theme.palette.mode === "dark" ? "#00bdd6" : "#00bdd6",
          opacity: 1,
          border: 0,
        },
        "&.Mui-disabled + .MuiSwitch-track": {
          opacity: 0.5,
        },
      },
      "&.Mui-focusVisible .MuiSwitch-thumb": {
        color: "#33cf4d",
        border: "6px solid #fff",
      },
      "&.Mui-disabled .MuiSwitch-thumb": {
        color: theme.palette.mode === "light" ? theme.palette.grey[100] : theme.palette.grey[600],
      },
      "&.Mui-disabled + .MuiSwitch-track": {
        opacity: theme.palette.mode === "light" ? 0.7 : 0.3,
      },
    },
    "& .MuiSwitch-thumb": {
      boxSizing: "border-box",
      width: 16,
      height: 16,
    },
    "& .MuiSwitch-track": {
      borderRadius: 26 / 2,
      backgroundColor: theme.palette.mode === "light" ? "#00bdd6" : "#00bdd6",
      opacity: 1,
      transition: theme.transitions.create(["background-color"], {
        duration: 500,
      }),
    },
  }));

  const [snackbar, setSnackbar] = useState(false);
  const [message, setMessage] = useState("");
  const [severity, setSeverity] = useState("success");

  const onClose = () => {
    setSnackbar(false);
  };

  //Press enter ==> submit message && press shift+enter ==> next line
  const handleKeyDown = (e) => {
    if (!props.browserMode && props?.brainList?.length === 0 && e.key === "Enter" && !e.shiftKey) {
      setSeverity("error");
      setMessage("Please create 'New Folder' to chat in folder mode");
      setSnackbar(true);
    } else if (!props.browserMode && props?.brainList?.length > 0 && !props.request && e.key === "Enter" && !e.shiftKey) {
      setSeverity("error");
      setMessage("Please write a prompt to chat in folder mode");
      setSnackbar(true);
    } else if (props.browserMode && !props.request && e.key === "Enter" && !e.shiftKey) {
      setSeverity("error");
      setMessage("Please write a prompt to chat in browser mode");
      setSnackbar(true);
    } else if (e.key === "Enter" && !e.shiftKey && !(props.browserMode && !props.request) && !(!props.browserMode && (!props.request || !props?.brainList || props?.brainList?.length === 0))) {
      e.preventDefault();
      props.handleMessage(props.request);
    }
  };

  //filter open  function start//
  const [anchorElfocus, setAnchorElfocus] = React.useState(null);
  const handleClickfocus = (event) => {
    setAnchorElfocus(event.currentTarget);
  };
  const handleClosefocus = () => {
    setAnchorElfocus(null);
  };
  const openfocus = Boolean(anchorElfocus);
  //filter open  function end//

  //browser toggle functionality begins

  const [browserMode, setBrowserMode] = useState(true);
  const handleBrowserToggle = () => {
    setBrowserMode((prevMode) => (prevMode === true ? false : true));
  };
  const [tooltipOpen, setTooltipOpen] = React.useState(false);

  //browser toggle functionality ends

  const ITEM_HEIGHT = 80;
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const [selectedModel, setSelectedModel] = useState('7');
  const handleModelSelect = (key) => {
    props.setModel(key);
    setSelectedModel(key);
  };
  //choose model end

  return (
    <div>
      <MessageSnackbar open={snackbar} autoHideDuration={3000} onClose={onClose} severity={severity} message={message} />
      <div className="chat_form   ">
        <div className="chat_form_box">
          {props?.selectedText !== "" && (
            <div className="reply_chat" style={{ display: "flex" }}>
              <motion.div initial={{ opacity: 0, y: 30 }} animate={{ opacity: 1, y: 0 }} transition={{ duration: 0.2, delay: 0.2 }} className="chat_material_content">
                <div className="rply-actions">
                  <Tooltip className="blue-tooltip" title="Close" TransitionComponent={Zoom} placement="top" arrow>
                    <IconButton
                      onClick={() => {
                        props?.setSelectedText("");
                      }}
                    >
                      <CloseIcon />
                    </IconButton>
                  </Tooltip>
                </div>

                <div className="chat_material_body">
                  <div className="chat_material_bar">
                    <span>
                      {props?.selectedText && props?.selectedText !== "" ? (
                        <ReactReadMoreReadLess charLimit={350} readMoreText={"Read more ▼"} readLessText={"Read less ▲"}>
                          {props?.selectedText}
                        </ReactReadMoreReadLess>
                      ) : (
                        "NA"
                      )}
                    </span>
                  </div>
                </div>
              </motion.div>
            </div>
          )}
          <div className="chat_form_flexbox">
            <div className="messageform">
              <TextField
                id="outlined-multiline-flexible"
                placeholder="Ask anything..."
                multiline
                value={props.transcript?.length > 0 ? props.transcript : props.request}
                onChange={(e) => {
                  props.setRequest(e.target.value);
                }}
                onKeyDown={handleKeyDown}
              />
              <div className={`listeningvoice ${props.listening ? "listening" : ""}`}>
                <LinearProgress />
                {props.transcript?.length === 0 && (
                  <div className="typing-box">
                    <span>{props.transcript?.length > 0 ? props.transcript : "Listening..."}</span>
                    <div class="typing_loader"> </div>
                  </div>
                )}
              </div>
            </div>
            <div className="desk_chat_actions">
              <div className="left_actions">
                <div className="chatbot_bottom_actions p-0 ">
                  <div className="change_chat_version">
                    <Link
                      style={{ cursor: "pointer" }}
                      to="#"
                      className="d-flex gap-1 align-items-center  "
                      onClick={handleClick}
                      size="small"
                      aria-controls={open ? "account-menu" : undefined}
                      aria-haspopup="true"
                      aria-expanded={open ? "true" : undefined}
                    >
                      <Avatar src={openai} sx={{ width: 20, height: 20, padding: "1px" }}></Avatar>
                      <label>{props.models[props.model]}</label>
                    </Link>
                    <Menu
                        anchorEl={anchorEl}
                        id="account-menu"
                        open={open}
                        onClose={handleClose}
                        onClick={handleClose}
                        MenuListProps={{
                          "aria-labelledby": "basic-button",
                        }}
                        PaperProps={{
                          style: {
                            maxHeight: ITEM_HEIGHT * 4.5,
                            width: "20ch",
                          },
                        }}
                        className="account-menu"
                      >
                      {Object.keys(props.models).map((key) => (
                        <MenuItem
                          key={key}
                          onClick={() => handleModelSelect(key)}
                          // Add the 'active' class if this is the selected model
                          selected={selectedModel === key}
                        >
                          <div className="gpt_item">
                            <div className="gtp_icon">
                              <Avatar sx={{ width: 30, height: 30, padding: "5px", backgroundColor: "#fafafa" }}>
                                <SwitchAccessShortcutAddIcon style={{ color: "#000" }} />
                              </Avatar>
                            </div>
                            <div className="gtp_content">
                              <h4>{props.models[key]}</h4>
                              {/* <span>Model details</span> */}
                            </div>
                          </div>
                        </MenuItem>
                      ))}
                    </Menu>
                  </div>
                  {props?.chatLength === 0 && props?.chatType !== "browser" && (
                    <div className="switchlanguage">
                      {/* <Tooltip
                        className="blue-tooltip"
                        title="Change Chat"
                        TransitionComponent={Zoom}
                        placement="bottom"
                        arrow
                        open={tooltipOpen}
                        disableHoverListener={tooltipOpen}
                        onOpen={() => setTooltipOpen(true)}
                        onClose={() => setTooltipOpen(false)}
                      > */}

                      <div className="d-flex align-items-center ">
                        <span className={props?.browserMode ? "text-success" : ""}>Browser</span>
                        <FormControlLabel
                          size="small"
                          className="m-0"
                          control={
                            <IOSSwitch
                              size="small"
                              sx={{ m: 1 }}
                              fontSize="small"
                              checked={!props?.browserMode}
                              onChange={() => {
                                props.handleBrowserToggle();
                                setTooltipOpen(false);
                              }}
                            />
                          }
                          // label={props?.browserMode ? "Browser" : "Brain"}
                        />
                        <span className={props?.browserMode ? "" : "text-success"}>Folder</span>
                      </div>
                      {/* </Tooltip> */}
                    </div>
                  )}
                  {props.browserMode === false && props?.brainList?.length > 0 && (
                    <>
                      <div className="chat_brain_change">
                        {props?.brainList?.length > 0 && (
                          <span className="changebrainthrew ">{props.selectedBrain === "Browser" ? <TravelExploreIcon fontSize="small" /> : <FolderOutlinedIcon fontSize="small" />}</span>
                        )}
                        {props.browserMode === false && (
                          <>
                          <Autocomplete
                            disablePortal
                            id="combo-box-demo"
                            options={props.brainList}
                            size="small"
                            PopperComponent={CustomPopper}
                            getOptionLabel={(option) => option.name ? option.name : "Untitled"}
                            onChange={(event, newValue) => {
                                props.setSelectedbrain(newValue);
                            }}
                            renderInput={(params) => (
                                <TextField {...params} label="Search Folder" />
                            )}
                            defaultValue={props.brainList && props.brainList.length > 0 ? props.brainList[0] : null}
                        />
                          {/* <FormControl fullWidth size="small">
                            <Select labelId="demo-select-small-label" id="demo-select-small" value={props?.selectedBrain ? props?.selectedBrain?.id : brainId ? brainId : "NA"}>
                              {props.brainList &&
                                props.brainList?.length > 0 &&
                                props.brainList?.map((brain) => {
                                  return (
                                    <MenuItem
                                      key={brain.id}
                                      value={brain.id}
                                      onClick={() => {
                                        props.setSelectedbrain(brain);
                                      }}
                                    >
                                      
                                    </MenuItem>
                                  );
                                })}
                            </Select>
                          </FormControl> */}
                          </>
                        )}
                      </div>
                      <div className="addbraininfo  ">
                        <Tooltip className="blue-tooltip" title="Create New Folder" TransitionComponent={Zoom} placement="top" arrow>
                          <IconButton color="primary" aria-label="add to shopping cart" onClick={activeaddbrain}>
                            <AddIcon fontSize="small" />
                          </IconButton>
                        </Tooltip>
                      </div>
                    </>
                  )}
                  {props.browserMode === false && props?.brainList?.length === 0 && (
                    <button type="button" className="btn btn-default" onClick={activeaddbrain}>
                      <AddIcon fontSize="small" />
                      Create New Folder
                    </button>
                  )}
                </div>
              </div>

              {/* <FormControlLabel
               control={<IOSSwitch sx={{ m: 1 }} defaultChecked />}
               label="Copilot"
               /> */}

              {/* <span className="my-organization">
               <Tooltip className="blue-tooltip" title="Add Attachment" TransitionComponent={Zoom} placement="top" arrow>
                  <Button
                  style={{textTransform:'capitalize', color:'#000', borderColor:'#000'}}
                  onClick={handleClickattachment}
                  variant="outlined"  
                  startIcon={
                  <AddIcon />
                  }>
                  Attach</Button>
               </Tooltip>
            </span> */}

              {/* <span className="my-organization">
                  <Tooltip
                    className="blue-tooltip"
                    title="Add Focus"
                    TransitionComponent={Zoom}
                    placement="top"
                    arrow
                  >
                    <Button
                      style={{
                        textTransform: "capitalize",
                        color: "#000",
                        borderColor: "#000",
                      }}
                      onClick={handleClickfocus}
                      variant="outlined"
                      startIcon={<FilterListIcon />}
                    >
                      Focus
                    </Button>
                  </Tooltip>
                </span> */}
              <div className="send_btn">
                <button
                  type="button"
                  className={`senderbtn bg-danger text-white ${props.listening ? "listening" : ""}`}
                  // disabled={window.navigator.brave && window.navigator.brave.isBrave.name === 'isBrave'}
                  onClick={() => {
                    if (window.navigator.brave && window.navigator.brave.isBrave.name === "isBrave") {
                      props.setMicOn(false);
                      setSeverity("error");
                      setMessage("Not supported in Brave. Please use a different browser or type your prompt.");
                      setSnackbar(true);
                    } else {
                      props.handleMic();
                    }
                  }}
                >
                  <div className={`pulse-ring ${props.listening ? "listening" : ""}`}></div>
                  <MicOutlinedIcon />
                </button>
                {!props.listening && (
                  <button
                    type="button"
                    className="senderbtn "
                    disabled={(props.browserMode && !props.request) || (!props.browserMode && (!props.request || !props?.brainList || props?.brainList?.length === 0))}
                    onClick={() => {
                      props.handleMessage(props.request);
                      props?.setSelectedText("");
                    }}
                  >
                    <EastOutlinedIcon />
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
      <Popover
        open={openattachment}
        anchorEl={anchorElattachment}
        onClose={handleCloseattachment}
        className="chatpopover"
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <div className="action-popup-wrapper desktoppopup">
          <div className="action-popup-head">
            <div className="actionpopup_title">Attachment</div>
            <Link to="#" className="slide-close" onClick={handleCloseattachment}>
              <span>X</span>
            </Link>
          </div>
          <div className="action-popup-body">
            <div className="Attachment_upload">
              <div className="form-group">
                <div className="csv-upload ">
                  <div className="upload-pdf">
                    <label htmlFor="file-upload1">
                      <input type="file" id="file-upload1" style={{ visibility: "hidden" }} />
                      <div className="svg-circle">
                        <FileUploadOutlinedIcon />
                      </div>
                      <h5> Drag and drop PDF files to upload </h5>
                      <p>Your PDF will be private until you publish them. </p>
                    </label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Popover>
      <Popover
        open={openfocus}
        anchorEl={anchorElfocus}
        onClose={handleClosefocus}
        className="chatpopover"
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "center",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "center",
        }}
      >
        <div className="action-popup-wrapper desktoppopup">
          <div className="action-popup-head">
            <div className="actionpopup_title">Focus</div>
            <Link to="#" className="slide-close" onClick={handleClosefocus}>
              <span>X</span>
            </Link>
          </div>
          <div className="action-popup-body p-0">
            <div className="focus_items">
              <div className="focus_cta">
                <Link to="">
                  <h5>
                    {" "}
                    <img src={all} height={20} /> All
                  </h5>
                  <span>Search across the entire internet</span>
                </Link>
              </div>

              <div className="focus_cta">
                <Link to="">
                  <h5>
                    {" "}
                    <img src={Academic} height={20} /> Academic
                  </h5>
                  <span>Search in published academic papers</span>
                </Link>
              </div>
              <div className="focus_cta">
                <Link to="">
                  <h5>
                    {" "}
                    <img src={Writing} height={20} /> Writing
                  </h5>
                  <span>Generate text or chat without searching the web</span>
                </Link>
              </div>

              <div className="focus_cta">
                <Link to="">
                  <h5>
                    <img src={divide} height={20} /> Wolfram | Alpha
                  </h5>
                  <span>Computational knowledge engine</span>
                </Link>
              </div>
              <div className="focus_cta">
                <Link to="">
                  <h5>
                    <img src={youtube} height={20} /> YouTube
                  </h5>
                  <span>Discover and watch videos</span>
                </Link>
              </div>
              <div className="focus_cta">
                <Link to="">
                  <h5>
                    <img src={reddit} height={20} /> Reddit
                  </h5>
                  <span>Search for discussions and opinions</span>
                </Link>
              </div>
            </div>
          </div>
        </div>
      </Popover>
      <AddBrain
        brainList={props.brainList}
        setBrainList={props.setBrainList}
        openaddbrain={openaddbrain}
        handleCloseaddbrain={handleCloseaddbrain}
        getbrains={props.getbrains}
        selectedBrain={props.selectedBrain}
        setSelectedbrain={props.setSelectedbrain}
        brainLoaded={props.brainLoaded}
        setBrainLoaded={props.setBrainLoaded}
      />
    </div>
  );
};
export default ChatForm;
